<template>
  <div>
    <!-- <div v-if="activeSubscription"> -->

    <div class="pa-2 my-2">
      <v-text-field
        v-model="search"
        hide-details
        outlined
        dense
        placeholder="Search CLs"
        class="my-2"
        @keyup.enter="doSearch()"
        ref="input"
      ></v-text-field>
      <rx-parser
        class="mx-2"
        buttonColor="#E3F2FD "
        buttonStyle="border:1px solid #6d899d"
        triggerTitle="Rx Search"
        :disabled="!activeSubscription"
        goToPage="/cls/rx"
        image="phoropter"
        :canOpenFromMenu="true"
      ></rx-parser>
    </div>
    <!-- </div> -->
    <!-- <span class="overline ml-3">Lens Type</span> -->
    <select-soft-type></select-soft-type>
    <v-divider class="my-1"></v-divider>
    <!-- <span class="overline ml-3">Manufacturer</span> -->

    <select-soft-company class=""></select-soft-company>

    <v-divider class="my-1"></v-divider>

    <v-list dense shaped color="transparent">
      <v-list-item-group color="primary">
        <v-list-item to="/cls/privateLabels">
          <v-list-item-icon class="mx-0">
            <img
              src="https://www.eyedock.com/images/menu_icons/private_label_icon.svg"
              width="28"
              class="mr-2"
            />
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Private Label SCLs</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/cls/advanced-search">
          <v-list-item-icon class="mx-0">
            <v-icon color="primary" class="mr-2">mdi-database-search</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Advanced CL Searches</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider class="my-1"></v-divider>

        <v-list-item to="/cl-products">
          <v-list-item-icon class="mx-0">
            <img
              src="https://www.eyedock.com/images/menu_icons/red_cap_bottle.svg"
              width="28"
              class="mr-2"
            />
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>CL Care Products</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </div>
</template>

<script>
// import Name from "../dir/file";
import UserMixin from "@/assets/js/UserMixin";

export default {
  name: "clMenuBtns",
  components: {
    RxParser: () => import("@/components/clStuff/RxParser"),
    SelectSoftType: () => import("@/components/clStuff/SelectSoftType.vue"),
    SelectSoftCompany: () =>
      import("@/components/clStuff/SelectSoftCompany.vue"),
  },
  mixins: [UserMixin],
  props: {},
  data: function () {
    return { search: null };
  },
  methods: {
    doSearch() {
      if (this.search) {
        this.$router.push({
          path: "/cls/search?q=" + encodeURI(this.search),
        });
        this.$refs.input.reset();
      }
      // ! if changing this, remember there is also a search function in /views/conditions (for small screens)
    },
  },
  computed: {},

  created() {
    if (!this.$store.state.clCompanies) this.$store.dispatch("loadCompanies");
  },
};
</script>

<style scoped></style>
